module.exports = __webpack_public_path__ + "static/media/onboarding-1.f69872fa.svg";